import { Component, HostListener, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from './auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'cards';

  constructor(private translate: TranslateService, private localStorage: LocalStorageService, private authService: AuthService) {
    this.translate.addLangs(["ar", "en"]);
  }

  ngOnInit() {

  }
}
